import Timeline from './Timeline';
import TimelineConnector from './TimelineConnector';
import TimelineContent from './TimelineContent';
import TimelineDot from './TimelineDot';
import TimelineItem from './TimelineItem';
import TimelineOppositeContent from './TimelineOppositeContent';
import TimelineSeparator from './TimelineSeparator';
import { TimelineProps } from '@material-ui/lab/Timeline';

export { TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator };
export type { TimelineProps };
export default Timeline;
